import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import BaseDetailScreen from '../BaseDetailScreen';
import Currency from '../Currency';
import { formatQuantity } from '../SecurityDetail/SecurityDetail';

import './NonTradedDetail.css';


const Ticker = ticker => (
  <div styleName="ticker">
    { `(${ticker})` }
  </div>
);

const NonTradedDetail = (props) => {
  const {
    security,
    securityId,
  } = props;
  return (
    <div>
      <BaseDetailScreen
        pageHeading={security.name}
        pageSubheading={(Ticker(security.ticker))}
        backTo="/portfolio"
        backLabel="Summary"
      >
        <div styleName="detail">
          <div styleName="totalValueSection">
            <div styleName="totalValueLabel">
              Total Value
            </div>
            <Currency styleName="totalValue" amount={security.totalValue} />
          </div>
          <div styleName="sectionBreak" />
          <div styleName="holdingInfoRow">
            <div styleName="holdingInfoColLeft">
              <div styleName="holdingInfoLabel">
                Total Cost
              </div>
              <Currency styleName="holdingInfoValue" amount={security.totalCost} />
            </div>
            <div styleName="holdingInfoColRight">
              <div styleName="holdingInfoLabel">
                Share Quantity
              </div>
              <div styleName="holdingInfoValue">
                { formatQuantity(security.quantity) }
              </div>
            </div>
          </div>
          <div styleName="holdingInfoRow">
            <div styleName="holdingInfoColLeft">
              <div styleName="holdingInfoLabel">
                Purchase Price
              </div>
              <Currency styleName="holdingInfoValue" amount={security.purchasePrice} />
            </div>
            <div styleName="holdingInfoColRight">
              <div styleName="holdingInfoLabel">
                Share Value
              </div>
              <Currency styleName="holdingInfoValue" amount={security.currentPrice} />
            </div>
          </div>
          <div styleName="disclaimer">
            Please note values for such securities may display a lower value than the price
            you paid for securities.&nbsp;
            <Link
              styleName="promptBlue"
              to={`/non-traded-info/${securityId}`}
            >
                Click here for more information regarding the value.
            </Link>
          </div>
        </div>
      </BaseDetailScreen>
    </div>
  );
};

NonTradedDetail.propTypes = {
  securityId: PropTypes.string,
  security: PropTypes.shape({
    name: PropTypes.string,
    quantity: PropTypes.number,
    purchasePrice: PropTypes.number,
    totalCost: PropTypes.number,
    currentPrice: PropTypes.number,
    totalValue: PropTypes.number,
  }),
};

NonTradedDetail.defaultProps = {
  securityId: '',
  security: {
    name: 'Not Found',
    quantity: null,
    purchasePrice: null,
    totalCost: null,
    currentPrice: null,
    totalValue: null,
  },
};

export default NonTradedDetail;



// WEBPACK FOOTER //
// ./src/components/NonTradedDetail/NonTradedDetail.js